module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view economy"
  }, [_c('div', {
    staticClass: "filterbtns"
  }, _vm._l((_vm.tabs), function(tab, tab_i) {
    return _c('filterbtn', {
      key: 'tab' + tab_i,
      attrs: {
        "active": _vm.tab_key_active == tab.key
      },
      nativeOn: {
        "click": function($event) {
          _vm.tab_key_active = tab.key
        }
      }
    }, [_vm._v(_vm._s(tab.label))])
  }), 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.tab_key_active == 'main') ? _c('box', {
    attrs: {
      "label": 'Overblik: ' + _vm.yearTitle
    }
  }, [_c('template', {
    slot: "meta-r"
  }, [(true) ? [_c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.toggle_calculate_hypothetic_posts()
      }
    }
  }, [(_vm.calculate_hypothetic_posts) ? [_vm._v("● Hypotetiske")] : [_vm._v("○ Hypotetiske")]], 2), _vm._v("\n             \n          "), (_vm.place_posts_by == 'invoice_date') ? _c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        _vm.place_posts_by = 'payment_due_date'
      }
    }
  }, [_vm._v("Regnskab")]) : _vm._e(), _vm._v(" "), (_vm.place_posts_by == 'payment_due_date') ? _c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        _vm.place_posts_by = 'invoice_date'
      }
    }
  }, [_vm._v("Likviditet")]) : _vm._e(), _vm._v("\n                         \n        ")] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.gotoPrevMonth()
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/chevron-left"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.gotoNextMonth()
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/chevron-right"
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "hidden"
    }
  }, [_c('table', {
    staticClass: "table-eco"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.activeYearPosts), function(month, month_i) {
    return _c('th', {
      staticClass: "monthCLickTitle",
      class: {
        active: (_vm.activeMonthNumber == (month.month))
      },
      on: {
        "click": function($event) {
          return _vm.gotoMonthYear(month.month, month.year)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.monthName(month.month))), _c('br'), _vm._v(" " + _vm._s(month.year) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('tbody', [_c('tr', {}, [_c('td', [_vm._v("Indtægter")]), _vm._v(" "), _vm._l((12), function(i) {
    return _c('td', {
      class: _vm.negaPosi_cls(_vm.activeYearPosts[i - 1].totals.income_total)
    }, [_vm._v(_vm._s(_vm.outputMoney(_vm.activeYearPosts[i - 1].totals.income_total)))])
  })], 2), _vm._v(" "), _c('tr', {}, [_c('td', [_vm._v("Udgifter")]), _vm._v(" "), _vm._l((12), function(i) {
    return _c('td', {
      class: _vm.negaPosi_cls(_vm.activeYearPosts[i - 1].totals.expense_total)
    }, [_vm._v(_vm._s(_vm.outputMoney(_vm.activeYearPosts[i - 1].totals.expense_total)))])
  })], 2), _vm._v(" "), _c('tr', {
    staticClass: "spacer"
  }, [_c('td', {
    attrs: {
      "colspan": "13"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Total")])]), _vm._v(" "), _vm._l((12), function(i) {
    return _c('td', {
      class: _vm.negaPosi_cls(_vm.activeYearPosts[i - 1].totals.total)
    }, [_c('b', [_vm._v(_vm._s(_vm.outputMoney(_vm.activeYearPosts[i - 1].totals.total)))])])
  })], 2), _vm._v(" "), _c('tr', {
    staticClass: "spacer"
  }, [_c('td', {
    attrs: {
      "colspan": "13"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bankbeholdning")]), _vm._v(" "), _vm._l((12), function(i) {
    return _c('td', {
      class: _vm.negaPosi_cls(10)
    }, [_vm._v(_vm._s(_vm.outputMoney(10)))])
  })], 2)])])])], 2) : _vm._e(), _vm._v(" "), (_vm.tab_key_active == 'main') ? _c('box', {
    attrs: {
      "label": 'Økonomiposter: ' + _vm.now.format('MMM YYYY')
    }
  }, [_c('template', {
    slot: "meta-r"
  }, [_c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.gotoPrevMonth()
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/chevron-left"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.gotoNextMonth()
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/chevron-right"
    }
  })], 1)]), _vm._v(" "), _c('economy-posts', {
    attrs: {
      "posts": _vm.activeMonthPosts.posts,
      "totals": _vm.activeMonthPosts.totals
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.createNewEconomypost()
      }
    }
  }, [_vm._v("Opret ny økonomipost")])], 2) : _vm._e(), _vm._v(" "), (_vm.tab_key_active == 'keyfigs') ? _c('box', {
    attrs: {
      "label": 'Nøgletal ' + _vm.yearTitle,
      "open": _vm.keyFiguresExpanded
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.flipBoolean('keyFiguresExpanded')
      }
    }
  }, [_c('table', {
    staticClass: "table-eco"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((4), function(i) {
    return _c('th', [_vm._v("Q" + _vm._s(i))])
  }), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.yearTitle))])], 2)]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Indtægter")]), _vm._v(" "), _vm._l((4), function(i) {
    return _c('td', {
      staticClass: "posi"
    }, [_vm._v(_vm._s(_vm.outputMoney(_vm.activeYearTotals['q' + i].income, 0)))])
  }), _vm._v(" "), _c('td', {
    staticClass: "posi"
  }, [_vm._v(_vm._s(_vm.outputMoney(_vm.activeYearTotals.year.income, 0)))])], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Udgifter")]), _vm._v(" "), _vm._l((4), function(i) {
    return _c('td', {
      staticClass: "nega"
    }, [_vm._v(_vm._s(_vm.outputMoney(_vm.activeYearTotals['q' + i].expense, 0)))])
  }), _vm._v(" "), _c('td', {
    staticClass: "nega"
  }, [_vm._v(_vm._s(_vm.outputMoney(_vm.activeYearTotals.year.expense, 0)))])], 2), _vm._v(" "), _c('tr', {
    staticClass: "spacer"
  }, [_c('td', {
    attrs: {
      "colspan": "6"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Total")])]), _vm._v(" "), _vm._l((4), function(i) {
    return _c('td', {
      class: _vm.negaPosi_cls(_vm.activeYearTotals['q' + i].total)
    }, [_c('b', [_vm._v(_vm._s(_vm.outputMoney(_vm.activeYearTotals['q' + i].total, 0)))])])
  }), _vm._v(" "), _c('td', {
    class: _vm.negaPosi_cls(_vm.activeYearTotals.year.total)
  }, [_c('b', [_vm._v(_vm._s(_vm.outputMoney(_vm.activeYearTotals.year.total, 0)))])])], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.tab_key_active == 'missing') ? _c('box', {
    attrs: {
      "label": "Mangler fakturering",
      "open": _vm.missingInvoiceExpanded
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.flipBoolean('missingInvoiceExpanded')
      }
    }
  }, [_c('p', [_vm._v("Her vises alle posteringer som mangler fakturering, så de kan behandles.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Total: " + _vm._s(_vm.outputMoney(_vm.needing_invoices.totals.total)) + " kr.")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.needing_invoices.posts), function(p) {
    return [_c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.openEconomypost(p)
        }
      }
    }, [_vm._v("\n        " + _vm._s(p.title || 'Unnamed') + " — " + _vm._s(_vm.outputMoney(p.amount_dkk_ex_vat)) + " kr.\n      ")]), _vm._v("   \n    ")]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.tab_key_active == 'missing') ? _c('box', {
    attrs: {
      "label": "Mangler betaling",
      "open": _vm.missingPaymentExpanded
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.flipBoolean('missingPaymentExpanded')
      }
    }
  }, [_c('p', [_vm._v("Her vises alle posteringer som mangler bettaling, så de kan behandles.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Total: " + _vm._s(_vm.outputMoney(_vm.needing_payment.totals.total)) + " kr.")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.needing_payment.posts), function(p) {
    return [_c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.openEconomypost(p)
        }
      }
    }, [_vm._v("\n        " + _vm._s(p.title || 'Unnamed') + " — " + _vm._s(_vm.outputMoney(p.amount_dkk_ex_vat)) + " kr.\n      ")]), _vm._v("   \n    ")]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.tab_key_active == 'vat') ? _c('box', {
    attrs: {
      "label": "Momsafregning",
      "open": _vm.vatViewExpanded
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.flipBoolean('vatViewExpanded')
      }
    }
  }, [_c('p', [_vm._v("Her vises moms +/-/total på måneds, kvartals og halvårsbasis")])]) : _vm._e(), _vm._v(" "), (false) ? _c('box', {
    attrs: {
      "label": "Indtjening"
    }
  }, [_c('template', {
    slot: "meta-r"
  }, [_c('div', {
    staticClass: "textlink"
  }, [_vm._v("\n        —\n      ")])]), _vm._v("\n\n    " + _vm._s(_vm.chart1) + "\n\n    "), _c('vue-chart', {
    attrs: {
      "columns": [{
        type: 'string',
        label: 'year'
      }, {
        type: 'string',
        label: 'year2'
      }, {
        type: 'string',
        label: 'year3'
      }],
      "rows": [
        [200, 33, 442],
        [100, 133, 242]
      ],
      "options": {}
    }
  })], 2) : _vm._e(), _vm._v(" "), (false) ? _c('box', {
    attrs: {
      "label": 'Samlet kundeindtjening',
      "open": _vm.clientEarningsExpanded
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.flipBoolean('clientEarningsExpanded')
      }
    }
  }, [_vm._v(">\n    "), _c('template', {
    slot: "meta-r"
  }, [_vm._v("\n      fra "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_earnings_date_from),
      expression: "client_earnings_date_from"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.client_earnings_date_from)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client_earnings_date_from = $event.target.value
      }
    }
  }), _vm._v(" til "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_earnings_date_to),
      expression: "client_earnings_date_to"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.client_earnings_date_to)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client_earnings_date_to = $event.target.value
      }
    }
  }), _vm._v("\n              \n    ")]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m50"
  }, [_c('div', {
    staticClass: "chart-minitable"
  }, [_c('peity', {
    attrs: {
      "type": 'pie',
      "options": {
        'fill': _vm.pieChartColors,
        width: 250,
        height: 250,
        'innerRadius': 0,
        'radius': 140
      },
      "data": _vm.clientsEconomyListPieData
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col m50"
  }, [_c('div', {
    staticClass: "chart-minitable"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Kunder")]), _vm._v(" "), _vm._l((_vm.clientsEconomyList), function(entry, i) {
    return _c('div', {
      staticClass: "entry"
    }, [_c('span', {
      staticClass: "colorcircle",
      style: ({
        'background-color': _vm.pieChartColors[i]
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v("\n              " + _vm._s(_vm.clients[entry.client_key].name) + "\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "pct"
    }, [_vm._v("\n              " + _vm._s(entry.pct) + " %\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "hours"
    }, [_vm._v("\n              " + _vm._s(_vm.outputMoney(entry.earning, 'a')) + " kr.\n            ")])])
  })], 2)])])], 2) : _vm._e(), _vm._v(" "), (false && _vm.globals.show_beta_content) ? _c('box', {
    attrs: {
      "label": 'Chart'
    }
  }, [_c('vue-chartist', {
    attrs: {
      "data": _vm.chartist_data,
      "options": _vm.chartist_options,
      "type": "Line"
    }
  })], 1) : _vm._e(), _vm._v(" "), (false && _vm.globals.show_beta_content) ? _c('box', {
    attrs: {
      "label": 'År: ' + _vm.activeYear
    }
  }, [_c('p', [_vm._v("Sparkline chart over månederne, med enten invoiced, eller også paid, eller begge.")]), _vm._v(" "), _c('table', {
    staticClass: "table-a"
  }, [_c('thead', [_c('tr', _vm._l((12), function(i) {
    return _c('th', {
      class: {
        'this-month': i == _vm.activeMonth
      }
    }, [(i == _vm.activeMonth) ? _c('span', [_vm._v(" --> ")]) : _vm._e(), _vm._v("\n            " + _vm._s(i) + "\n            "), (i == _vm.activeMonth) ? _c('span', [_vm._v(" <-- ")]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('tbody', [_c('tr', _vm._l((12), function(i) {
    return _c('td', {
      class: {
        'this-month': i == _vm.activeMonth
      }
    }, [_vm._v("\n            " + _vm._s(i) + "\n          ")])
  }), 0)])]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.yearStats) + "\n    ")]), _vm._v(" "), _c('trend', {
    attrs: {
      "data": _vm.yearStats,
      "gradient": ['#000', '#000', '#000'],
      "auto-draw": "",
      "smooth": ""
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5a50048","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Economy.vue
// module id = 620
// module chunks = 1